import { render, staticRenderFns } from "./PurchaseOrderInvoice.vue?vue&type=template&id=31795868&scoped=true"
import script from "./PurchaseOrderInvoice.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderInvoice.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderInvoice.vue?vue&type=style&index=0&id=31795868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31795868",
  null
  
)

export default component.exports